import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
} from "async-ops";
import { cloneDeep, cloneDeepWith, isEqual } from "lodash";
import {
  isMdaeWidgetOptionChangeEvent,
  updateStateAfterWidgetOptionChange,
} from "../../../../common_components/mdae-framework";
import { GET_EA_OUTCOMES_AUDIT_GROUP_LIST } from "../services/get-audit-group-list";
import { GET_OUTCOMES_LIST } from "../services/get-outcomes-list";
import { GET_OUTCOME_REFERENCE_DATA } from "../services/get-reference-data";
import { format } from "date-fns";
export const TOGGLE_CASE_ROUND_OUTCOME_LIST_ACTION_POPOVER =
  "TOGGLE_CASE_ROUND_OUTCOME_LIST_ACTION_POPOVER";
export const TOGGLE_CASE_FINAL_OUTCOME_LIST_ACTION_POPOVER =
  "TOGGLE_CASE_FINAL_OUTCOME_LIST_ACTION_POPOVER";
export const TOGGLE_CASE_ROUND_OUTCOME_POPUP =
  "TOGGLE_CASE_ROUND_OUTCOME_POPUP";
export const SET_CASE_ROUND_OUTCOME_FORM_DATA =
  "SET_CASE_ROUND_OUTCOME_FORM_DATA";
export const RESET_CASE_ROUND_OUTCOME_POPUP_VALIDATION =
  "RESET_CASE_ROUND_OUTCOME_POPUP_VALIDATION";
export const TOGGLE_OUTCOME_LIST_ACTION_POPOVER =
  "TOGGLE_OUTCOME_LIST_ACTION_POPOVER";
export const SET_OUTCOME_LIST = "SET_OUTCOME_LIST";
export const SET_OUTCOME_FORM_DATA = "SET_OUTCOME_FORM_DATA";
export const TOGGLE_OUTCOME_POPUP = "TOGGLE_OUTCOME_POPUP";
export const RESET_OUTCOME_POPUP_VALIDATION = "RESET_OUTCOME_POPUP_VALIDATION";
export const OUTCOME_TAB = {
  CRO: "Case Round Outcomes",
  CFO: "Case Final Outcomes",
  RLLO: "Round Line Level Outcomes",
};
export const OUTCOME_TAB_ENUM = {
  CaseRoundOutcome: "CRO",
  CaseFinalOutcome: "CFO",
  RoundLineLevelOutcome: "RLLO",
};
export const SET_CASE_FINAL_OUTCOME_LIST_WITH_TERM_DATE = "SET_CASE_FINAL_OUTCOME_LIST_WITH_TERM_DATE";

export const defaultOutcomeFormData = {
  eaOutcomeId: 0,
  eaOutcomeName: "",
  displayName: "",
  outcomeType: "",
  description: "",
  selectedAuditGroupIds: [],
  effectiveDate: new Date(),
  termDate: null,
  curatedInd: false,
  outcomeArea: OUTCOME_TAB_ENUM.CaseRoundOutcome,
  isSelectedOutcomeUsed: false,
  moveInProgressDollarToType:null
};

const initialState = {
  isLoading: false,
  caseRoundOutcomeList: [],
  caseFinalOutcomeList: [],
  roundLineLevelOutcomeList: [],
  outcomeList: [],
  outcomeFormData: defaultOutcomeFormData,
  outcomeTab: [OUTCOME_TAB.CRO, OUTCOME_TAB.CFO, OUTCOME_TAB.RLLO],
  tabSelected: OUTCOME_TAB.CRO,
  outcomeTypeList: [],
  hasAllAuditGroupAccess: false,
  auditGroupDataSourceList: [],
  moveInProgressDollarToTypeList:[],
  moveInProgressDollarToTypeEnums:{}
};

export default function(state = initialState, action) {
  let newState;
  switch (action.type) {
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      if (isAsyncOperation(GET_OUTCOMES_LIST)(action)) {
        return {
          ...state,
          caseRoundOutcomesList: [],
          caseFinalOutcomeList: [],
          outcomeList: [],
        };
      }
      if (isAsyncComplete(GET_OUTCOMES_LIST)(action)) {
        const response = action.response;
        let outcomeList = [];
        switch (state.tabSelected) {
          case OUTCOME_TAB.CRO:
            outcomeList = response.caseRoundOutcomeList;
            break;
          case OUTCOME_TAB.CFO:
            outcomeList = response.caseFinalOutcomeList;
            break;
          case OUTCOME_TAB.RLLO:
            outcomeList = response.roundLineLevelOutcomeList;
            break;
          default:
            outcomeList = [];
        }
        return {
          ...state,
          caseRoundOutcomeList: response.caseRoundOutcomeList,
          caseFinalOutcomeList: response.caseFinalOutcomeList,
          roundLineLevelOutcomeList: response.roundLineLevelOutcomeList,
          outcomeList: outcomeList,
          hasAllAuditGroupAccess: response.hasAllAuditGroupAccess,
        };
      }
      if (isAsyncOperation(GET_EA_OUTCOMES_AUDIT_GROUP_LIST)(action)) {
        return {
          ...state,
          auditGroupDataSourceList: [],
        };
      }
      if (isAsyncComplete(GET_EA_OUTCOMES_AUDIT_GROUP_LIST)(action)) {
        const response = action.response;
        defaultOutcomeFormData.selectedAuditGroupIds = response?.list.map(
          (x) => x.auditGroupId
        );
        return {
          ...state,
          auditGroupDataSourceList: response?.list,
        };
      }
      if (isAsyncOperation(GET_OUTCOME_REFERENCE_DATA)(action)) {
        return { ...state, outcomeTypeList: [],moveInProgressDollarToTypeList:[],moveInProgressDollarToTypeEnums:{} };
      }
      if (isAsyncComplete(GET_OUTCOME_REFERENCE_DATA)(action)) {
        const response = action.response;
        return {
          ...state,
          outcomeTypeList: response.outcomeTypeList,
          moveInProgressDollarToTypeList: response.moveInProgressDollarToTypeList,
          moveInProgressDollarToTypeEnums:response.moveInProgressDollarToTypeEnums
        };
      }
      return state;
    case SET_OUTCOME_LIST:
      return {
        ...state,
        outcomeList: action.data.outcomeList,
        tabSelected: action.data.tabSelected,
      };
    case SET_OUTCOME_FORM_DATA:
      newState = cloneDeepWith(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        const outcomeFormData = newState.outcomeFormData
          ? newState.outcomeFormData
          : {};
        for (let prop in action.data.outcomeFormData) {
          outcomeFormData[prop] = action.data.outcomeFormData[prop];
          if (
            prop == "selectedAuditGroupIds" &&
            action.data.outcomeFormData.selectedAuditGroupIds.length == 0
          ) {
            outcomeFormData.selectedAuditGroupIds = state.auditGroupDataSourceList?.map(
              (x) => x.auditGroupId
            );
          }
        }
        newState = { ...newState, outcomeFormData: outcomeFormData };
      }
      return newState;
    case TOGGLE_OUTCOME_LIST_ACTION_POPOVER:
    case TOGGLE_OUTCOME_POPUP:
    case RESET_OUTCOME_POPUP_VALIDATION:
    case SET_CASE_FINAL_OUTCOME_LIST_WITH_TERM_DATE:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;
    default:
      return state;
  }
}

export const formatOutcomeObjectToSave = (
  outcomeFormData,
  auditGroupDataSource,
  hasAllAuditGroupAccess
) => {
  outcomeFormData = cloneDeep(outcomeFormData);
  const auditGroupIdList = auditGroupDataSource.map((x) => x.auditGroupId);
  if (
    outcomeFormData.selectedAuditGroupIds?.length ===
      auditGroupIdList?.length &&
    isEqual(
      outcomeFormData.selectedAuditGroupIds.slice(0).sort(),
      auditGroupIdList.slice(0).sort()
    ) &&
    hasAllAuditGroupAccess
  ) {
    outcomeFormData.selectedAuditGroupIds = null;
  }
  outcomeFormData.effectiveDate = format(
    new Date(outcomeFormData.effectiveDate),
    "MM/DD/YYYY"
  );
  if (outcomeFormData.termDate)
    outcomeFormData.termDate = format(
      new Date(outcomeFormData.termDate),
      "MM/DD/YYYY"
    );
  delete outcomeFormData.createDate;
  delete outcomeFormData.updateDate;
  return outcomeFormData;
};
